// eslint-disable-next-line import/prefer-default-export
export const ValidationErrorMessage = {
  ErLeaveType: 'Please select leave type',
  ErPolicyDetails: 'Please add leave policy details',
  ErName: 'Please enter valid leave name',
  Erannualbalance: 'Please add annual balance',
  Eremployeetypeids: 'Please select employment type',
  Ergenderids: 'Please select gender type',
  Ermaritalstatusids: 'Please select marital status type',
  Ercreditmodetypeid: 'Please select credit mode type',
  Ermidjoinstartday: 'Please add mid join start day',
  Erdaysbefore: 'Please select credit days before',
  Erminleavecountforapp: 'Please add leave duration greater than',
  Ernotifyinadvanceday: 'Please add application must be made at least',
  Ernotifynotbeforeday: 'Please add leave application for future days',
  Ernotifynotbeforedaygreater: 'Please check future days',
  Erapppastday: 'Please add leave application for past days',
  Erclubbingleaveid: 'Please select clubbing leaves',
  Erexperienceinmonth: 'Please add experience in month',
  ErProRate: 'Please select Pro-rate',
  ErProRateType: 'Please select Pro-rate type',
  Erothercreditmodetypeid: 'Please select another credit mode type',
  Ercreditdaymonth: 'Please add credit day month',
  Erprobationaccurallimit: 'Please add probation accrual limit',
  Erisattachment: 'Please add attachment duration',
  ErisattachmentInst: 'Please add attachment Instruction',
  Erleavecountinnotice: 'Please add leave a count in notice',
  Erexcessleaveactiontypeid: 'Please select excess leave action type',
  Erexcesspaidlimit: 'Please add excess paid limit',
  ErLeaveBalanceAvailable: 'Please select when leave balance will be available for employees',
  ErProbationLeaves: 'Please add leave(s) for every 1 month of probation',
  ErLeaveDuringProbation: 'Please select days of leaves during probation',
  ErMaxLeaves: 'Please select days of leaves after confirmation',
  ErLeaveDuration: 'Please select leave duration',
  ErMaxConseLeaves: 'Please select maximum consecutive days of leaves',
  ErDeductLeaves: 'Please select how to you wish to deduct leaves',
  ErGiftLeave: 'Please select how you wish to gift leaves',
  ErEarnedLeaves: 'Please add earned leaves count',
  ErCompletionDays: 'Please select completion days',
  ErSpecificDay: 'Please select at least one specific day',
  ErExperience: 'Please add experience in months',
  Ernoofremaning: 'Please add no of remaining',
  Erremaningperc: 'Please add remaining percentage',
  Erpendingactiontypeid: 'Please select pending action type',
  Erencashmentunused: 'Please add encashment unused',
  Erencashmentunusedperc: 'Please add encashment percentage',
  Erencashmenttypeid: 'Please select encashment type',
  Ercarryforwardunusedperc: 'please add carry forward unused percentage',
  Ercarryforwardunused: 'Please add carry forward unused',
  Erforwardtypeid: 'Please select forward type',
  Ermaxmonthhour: 'Please add max month hour',
  Ermaxonedayhour: 'Please add max one day hour',
  Erminhour: 'Please add min one day hour',
  Erapprovaltypeid: 'Please select approval type ',
  Erprobationcreditlimit: 'Please add credit accrual limit',
  ErAltLeaveType: 'Please select an alternate leave type',
  ErCountLeave: 'Please select how to count extra Leaves',
  ErAccruedBtUncredited: 'Please select how to handle accrued but uncredited leaves',
};
